module.exports = __webpack_public_path__ + "static/AaronRobertshaw-Resume-OnePage-6534a9e80522da3b5ce816fa69d179e2.pdf";